package app.smartcoding.realrate.domain.tools

// В commonMain, където инициализирате вашия HttpClient
import app.smartcoding.realrate.domain.model.AppCheckTokenProvider
import io.ktor.client.*
import io.ktor.client.request.*

fun createKtorClient(tokenProvider: AppCheckTokenProvider): HttpClient {
    val client = HttpClient {

    }

    client.requestPipeline.intercept(HttpRequestPipeline.State) {
        val token = tokenProvider.getToken()

        if (!token.isNullOrEmpty()) {
            context.headers.append("X-Firebase-AppCheck", token)
        }
    }

    return client
}